import { type PartialDeep } from 'type-fest';

import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsExtractor } from '../__base/props-extractor';

export class WizardPropsExtractor extends PropsExtractor<'wizard'> {
  override getPageReferences: () => string[] = () => {
    if (!this.props?.content) {
      return [];
    }
    const pageIds = this.props.content.steps?.items
      ?.map((s) => s?.postAction?.page)
      .filter(Boolean) as string[];

    return pageIds?.length ? pageIds : [];
  };

  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.container?.visualEffect;
}
